// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"33e2d463","150":"8c65ae2a","352":"b00c9b20","407":"a4c3b05d","453":"6e3371ff","525":"12b59e9b","690":"69bacda3","922":"3ea8382a"}[chunkId] + ".chunk.js";
};